// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1ya3u","fileDisabled":"File_fileDisabled__2jb60"};